// Grid import
import { Responsive, WidthProvider } from "react-grid-layout";
// Visuals imports
import PowerCard from '../components/visuals/PowerCard';
import ChartHandler from '../components/handlers/Chart-handler';
import EventsHandler from '../components/handlers/Events-handler';
import {
    Container,
  } from 'reactstrap';
import FastDataHandlerWithKey from '../components/handlers/FastData-handler';
import SiteInfoHandler from '../components/handlers/SiteInfo-handler';

const ResponsiveGridLayout = WidthProvider(Responsive);


const layoutLg = [
  { i: "site-info", x: 0, y: 0, w: 6, h: 1, minH: 1, minW: 6 },
  { i: "infoTable", x: 0, y: 1, w: 4, h: 2.25, minH: 2.25, minW: 4 },
  { i: "power", x: 5, y: 1, w: 2, h: 2.25, minH: 2.25, minW: 2 },
  { i: "status", x: 0, y: 4, w: 6, h: 1, minH: 1, minW: 6 },
  { i: "events", x: 0, y: 5, w: 6, h: 2, minH: 2, minW: 6 },
  { i: "chart", x: 0, y: 7, w: 6, h: 4, minH: 4, minW: 6  }
];

const layoutMd = [
  { i: "site-info", x: 0, y: 0, w: 6, h: 1, minH: 1, minW: 6 },
  { i: "infoTable", x: 0, y: 1, w: 4, h:2.25, minH: 2.25, minW: 4 },
  { i: "power", x: 5, y: 1, w: 2, h: 2.25, minH: 2.25, minW: 2 },
  { i: "status", x: 0, y: 4, w: 6, h: 1, minH: 1, minW: 6 },
  { i: "events", x: 0, y: 5, w: 6, h: 2, minH: 2, minW: 6 },
  { i: "chart", x: 0, y: 7, w: 6, h: 4, minH: 4, minW: 6  }
];

const layoutSm = [
  { i: "site-info", x: 0, y: 0, w: 4, h: 1, minH: 1, minW: 4 },
  { i: "infoTable", x: 0, y: 1, w: 2, h: 2.25, minH: 2.25, minW: 2 },
  { i: "power", x: 3, y: 1, w: 2, h: 2.25, minH: 2.25, minW: 2 },
  { i: "status", x: 0, y: 3, w: 4, h: 1, minH: 1, minW: 4 },
  { i: "events", x: 0, y: 4, w: 4, h: 2, minH: 2, minW: 4 },
  { i: "chart", x: 0, y: 6, w: 4, h: 2,  minH: 2, minW: 4  }
];

const layoutXs = [
  { i: "site-info", x: 0, y: 0, w: 2, h: 2, minH: 2, minW: 2 },
  { i: "infoTable", x: 0, y: 1, w: 2, h: 2.25, minH: 2.25, minW: 2 },
  { i: "power", x: 0, y: 3, w: 2, h: 2.25, minH: 2.25, minW: 2 },
  { i: "status", x: 0, y: 3, w: 2, h: 1, minH: 1, minW: 2 },
  { i: "events", x: 0, y: 4, w: 2, h: 2, minH: 2, minW: 2 },
  { i: "chart", x: 0, y: 6, w: 2, h: 2, minH: 2, minW: 2  }
];

const getLayouts = () => {
  return { lg: layoutLg, md: layoutMd, sm: layoutSm, xs: layoutXs };
};


export const HomeGrid = (props) => {

  const renderLoadingOrError = () => {
    if (props.isLoading) {
      return console.log('loading...')
    } else if (props.isError) {
      return console.log(props.errorMessage);
    }
    return null;
  };

  return (
    <>
      <Container>
        {renderLoadingOrError()}
        <ResponsiveGridLayout style={{zIndex:'0'}}
          layouts={getLayouts()}
          breakpoints={{ lg: 1920, md: 900, sm: 620, xs: 0 }}
          cols={{ lg: 8, md: 6, sm: 4, xs: 2 }}
          rowHeight={100}
          draggableCancel=".cancelSelectorName"
          isDraggable={false}
          isResizable={false}
        >
          <div key="site-info" style={{zIndex:'0'}}>
            <SiteInfoHandler className="cancelSelectorName"/>
          </div>
          <div key="power" className = "overflow-visible" style={{zIndex:'0'}}>
            <PowerCard/>
          </div>
          <div key="infoTable" className="overflow-visible" style={{ zIndex: '-1' }}>
            <FastDataHandlerWithKey/>
          </div>
          <div key="events" className = "overflow-visible" style={{zIndex:'-1'}}>
            <EventsHandler />
          </div>
          {/* <div key="status" className = "overflow-visible" style={{zIndex:'-1'}}>
            <SiteData />
          </div> */}
          <div key="chart" style={{ minHeight: '400px', zIndex:'-1' }}>
            <ChartHandler/>
          </div>
        </ResponsiveGridLayout>
      </Container>
    </>
  );
};